<template>

    <modal :show="showModal">

        <div class="mr-container">

            <h2 class="mr-title">{{ $t('pop_up_rating_title') }}</h2>

            <p class="mr-text">{{ $t('pop_up_rating_text') }}</p>

            <img class="mr-img" src="/img/foxy/rating/general@2x.png">

            <button class="btn btn-blue btn-mr" @click="rate">{{ $t('pop_up_rating_cta_trustpilot') }}</button>

            <button class="btn btn-mr" @click="cancel">{{ $t('pop_up_rating_cta_later') }}</button>

        </div>

    </modal>

</template>

<script>
import I18n from '@/modules/i18n'
import Share from '@/modules/share'
import Tag from '@/modules/tag'

import Modal from '@/components/modal/Modal'

export default {

    name: 'modal-rating',

    components: {Modal},

    data() {
        return {

            showModal: false

        }
    },

    methods: {

        closeModal(rate = false) {
            this.showModal = false
            this.$emit('close', rate)
        },

        open() {

            Tag.popupGa(this, 'rating')

            this.showModal = true
        },

        cancel() {

            Tag.clickGA(this, 'rate_later')

            this.closeModal()
        },

        rate() {

            Tag.clickGA(this, 'rate_next')

            Share.rate(I18n.get(this))

            this.closeModal(true)
        }
    }

}

</script>

<style lang="scss" scoped>

.mr-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 21px 0 8px;
    max-width: 288px;
    @media screen and (min-width: $above-tablet-length) {
        max-width: 512px;
    }
}

.mr-title {
    font-size: 21px;
    font-weight: bold;
    line-height: 1.14;
    text-align: center;
    color: $midnight;
}

.mr-text {
    font-size: 16px;
    font-weight: 500;
    line-height: 1.5;
    text-align: center;
    color: $secur-text;
    margin: 10px 0;
}

.mr-img {
    width: 100%;
    margin-top: 10px;
}

.btn-mr {
    margin-top: 8px;
    width: 256px;
    @media screen and (min-width: $above-tablet-length) {
        width: 448px;
    }
}

</style>
